module.exports = __webpack_public_path__ + "static/og-b0abe644feea35dda539e5831fcb23bf.png";